import { useMutation, useQueryClient } from '@tanstack/react-query';
import { UserQueryKeys } from '@enums/react-query-keys';
import UserService from '@services/user-service';

const useUploadProfilePicture = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (file: File) => UserService.uploadProfilePicture(file),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [UserQueryKeys.USER] }),
  });
};

export default useUploadProfilePicture;
